/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/** Syntactic sugar for casting */
export function asBatchMetadata(metadata) {
    return metadata;
}
/** Syntactic sugar for casting */
export function asEmptyBatchLocalOpMetadata(localOpMetadata) {
    return localOpMetadata;
}
//# sourceMappingURL=metadata.js.map